import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { Agent } from "@/api/generated";
import { layoutTokens, semanticColors, textStyles } from "@/designTokens";
import theme from "@/theme";
import { buildAgentName } from "@/utilities/agentName";

import { normalizeBeginnerMessage } from "./AgentBeginnerMessage";

const useStyles = makeStyles(() => ({
  root: { display: "flex", flexDirection: "column", gap: layoutTokens.space[12] },
  message: {
    display: "flex",
    flexDirection: "column",
    gap: layoutTokens.space[8],
    padding: `${layoutTokens.space[16]}px ${layoutTokens.space[16]}px ${layoutTokens.space[24]}px`,
    backgroundColor: semanticColors["surface/base"],
    overflowWrap: "anywhere",
  },
  caption: {
    ...textStyles["SP/Body/Small"],
    color: semanticColors["text/secondary"],
    [theme.breakpoints.up("md")]: { fontSize: textStyles["PC/Body/Small"].fontSize },
  },
  text: {
    ...textStyles["SP/Heading/H4"],
    lineHeight: 1.5,
    color: semanticColors["text/primary"],
    [theme.breakpoints.up("md")]: { fontSize: textStyles["PC/Heading/H4"].fontSize },
  },
  // Figma B-1 は 342×220。幅に合わせて同じ比率で切り抜く
  photo: {
    display: "block",
    width: "100%",
    aspectRatio: "342 / 220",
    objectFit: "cover",
    borderRadius: layoutTokens.radius.md,
  },
}));

/**
 * プランナー詳細の「ひとこと」と紹介写真（Figma B-1 の band-プランナーについて）。
 * ひとことは既存の beginner_message を流用し、ここでは「」を付けない。両方とも無ければ何も出さない。
 */
export const AgentIntroduction: React.FC<{ agent: Agent; className?: string }> = ({ agent, className }) => {
  const classes = useStyles();
  const message = normalizeBeginnerMessage(agent.beginner_message);
  const imageUrl = agent.agent_introduction_image?.image_url || "";
  if (!message && !imageUrl) return null;
  return (
    <Box className={`${classes.root} ${className ?? ""}`} data-testid="planner-introduction">
      {message && (
        <Box className={classes.message}>
          <Typography className={classes.caption}>認定プランナーからひとこと</Typography>
          <Typography className={classes.text} data-testid="planner-introduction-message">
            {message}
          </Typography>
        </Box>
      )}
      {imageUrl && (
        <img
          className={classes.photo}
          src={imageUrl}
          alt={`${buildAgentName(agent)}の紹介写真`}
          data-testid="planner-introduction-photo"
        />
      )}
    </Box>
  );
};
